import React from 'react'
import { useWatch } from 'react-hook-form'
import { isNullOrWhiteSpace } from '../../utilities/string'
import { RadioButton, RadioButtonProps } from './RadioButton'

export interface RadioButtonsProps {
  defaultValue?: string
  id?: string
  label?: string
  name: string
  options: Omit<RadioButtonProps, 'checked' | 'name'>[]
  required?: boolean
  validation?: true | string
}

export const RadioButtons = ({
  defaultValue,
  id,
  label,
  name,
  options,
  required,
  validation,
}: RadioButtonsProps) => {
  const activeValue = useWatch({ defaultValue, name })

  const radioButtonComponents = options.map((option, i) => (
    <RadioButton
      id={id ? `${id}-${i}` : undefined}
      {...option}
      additionalClassName="flex-none"
      checked={activeValue === option.value}
      key={option.value}
      name={name}
      validation={validation}
    />
  ))

  return !isNullOrWhiteSpace(label) ? (
    <fieldset>
      <legend className="font-t text-t-200 text-secondary-darker mb-10">
        {label}

        <span className="ml-5 text-shade-medium-dim">
          {required ? '(required)' : '(optional)'}
        </span>
      </legend>

      <div className="flex flex-wrap gap-10">{radioButtonComponents}</div>

      <div className="min-h-15 mt-5 text-secondary font-t text-t-200 leading-[15px]">
        {validation !== true && !isNullOrWhiteSpace(validation) && validation}
      </div>
    </fieldset>
  ) : (
    <>{radioButtonComponents}</>
  )
}
